/** This is a mapping of clinic `primaryColorHex` property to other navbar background colors based on clinic **/
export const NavBarClinicBackgroundColors: { [primaryColorHex: string]: { clinicBackground: string, menuBackground: string } } = {
	'#33CFCB': {clinicBackground: '#5BD8D5', menuBackground: '#74DEDB'}, // Akihabara
	'#FEDC7C': {clinicBackground: '#FEDC7C', menuBackground: '#FEE190'}, // Omiya
	'#8AAAE5': {clinicBackground: '#8AAAE5', menuBackground: '#9CB7E9'}, // Yokohama
	'#A7DC7A': {clinicBackground: '#A7DC7A', menuBackground: '#B0E089'}, // Umeda
	'#DCDC7B': {clinicBackground: '#DCDC7B', menuBackground: '#DFDF8A'} // Funabashi
};
